import type { SDSelectProps } from '.';
import type { TextFieldProps } from '@mui/material';
import { Select } from '.';

export const MultipleSelect: React.FC<SDSelectProps & TextFieldProps> = ({ ...props }) => (
  <Select
    {...props}
    SelectProps={{
      multiple: true,
    }}
  />
);
